<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="businessTypeform"
          status-icon
          :model="businessTypeform"
          :rules="rules"
          label-width="120px"
          class="businessTypeInfo"
          style="width: 90%;"
          v-loading="loading"
          :element-loading-text="loadingText"
        >
          <el-row>
            <el-col>
              <el-form-item label="商户类型" prop="BusinessTypeName">
                  <el-input v-model="businessTypeform.BusinessTypeName"></el-input>
              </el-form-item>
               <el-form-item label="排序" prop="BusinessTypeName">
                   <el-input-number :step="1" :min="0" :max="1000" v-model="businessTypeform.OrderIndex"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center;">
        <el-button type="primary" @click="Onsubmit('businessTypeform')" v-if="IsEdit">提交</el-button>
        <el-button @click="OnCancel" v-if="IsEdit">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  .avatar {
    width: 80px;
    height: 80px;
    display: block;
  }
</style>


<script>
import WebApis from "../../../apis";

export default {
  name: "BusinessTypeInfoPage",
  data() {
    return {
      businessTypeform: {
        BusinessTypeName: "",
        OrderIndex:0
      },
      rules: {
        BusinessTypeName:[
          { required: true, message: "请输入商户类型", trigger: "blur" }
        ]
      },
      resData: ""
    };
  },
  props: {
    BusinessType_Id: {
      type: String,
      default: "",
    },
    IsEdit: {
      type: Boolean,
      default: true,
    },
  },
  created: function () {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      this.GetInfo();
    },
    Onsubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SaveData();
        } else {
          this.$message({
            showClose: true,
            message: "填写内容不正确!",
            type: "error",
          });
          return false;
        }
      });
    },
    OnCancel() {
      this.$emit("clickCancel", {});
    },
    GetInfo() {
      if (this.BusinessType_Id) {

        let BusinessTypeSearch = {
          BusinessTypeId: this.BusinessType_Id,
        };
        return new WebApis.BusinessTypeApi()
          .GetItemByBusinessTypeId(BusinessTypeSearch)
          .then((res) => {
            console.log(res.data.Data);
            if (res.data.Data) {
              this.resData = res.data.Data;
              this.businessTypeform.BusinessTypeName = this.resData.BusinessTypeName;
              this.businessTypeform.OrderIndex = parseInt(this.resData.OrderIndex);
            }
          })
          .catch((e) => {
            this.$message({
              showClose: true,
              message: e.RspMsg
                ? "获取商户信息失败!" + e.RspMsg
                : "获取商户信息失败!",
              type: "error",
            });
            return false;
          });
      }
    },
    SaveData() {
      let BusinessTypeDTO = {
        Id: 0,
        BusinessTypeId: "",
        BusinessTypeName: this.businessTypeform.BusinessTypeName,
        OrderIndex: this.businessTypeform.OrderIndex,
        Validity: 1,
        Extend1: "",
        Extend2: "",
        Extend3: "",
      };

      if (this.resData) {
        console.log("商户类型详情",this.resData);
        BusinessTypeDTO.Id = this.resData.Id;
        BusinessTypeDTO.BusinessTypeId = this.resData.BusinessTypeId;
        BusinessTypeDTO.Modifier = this.user.UserName;
        BusinessTypeDTO.ModifyTime = new Date();
        BusinessTypeDTO.Validity = 1;
        this.UpdateData(BusinessTypeDTO);
      } else {
        BusinessTypeDTO.Creater = this.user.UserName;
        BusinessTypeDTO.CreateTime = new Date();
        BusinessTypeDTO.Modifier = this.user.UserName;
        BusinessTypeDTO.ModifyTime = new Date();
        BusinessTypeDTO.Validity = 1;
        this.InsertData(BusinessTypeDTO);
      }
    },
    InsertData(BusinessTypeDTO) {
      new WebApis.BusinessTypeApi()
        .AddItem(BusinessTypeDTO)
        .then((res) => {
          if (res.RspCode == "1") {
            this.$message({
              message: "商户类型添加成功!",
              type: "success",
            });

            this.$emit("clickOk", {});
          } else {
            this.$message({
              showClose: true,
              message: "添加商户类型失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "商户类型添加";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "商户类型添加成功" : "商户类型添加失败";
          this.logInfo.ModuleName = "商户类型管理";
          this.logInfo.PageName = "商户类型管理详情页面";
          this.addOperationLog();
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg ? "添加商户类型失败！" + e.RspMsg : "添加商户类型失败！",
            type: "error",
          });
          return false;
        });
    },
    UpdateData(BusinessTypeDTO) {
      new WebApis.BusinessTypeApi()
        .UpdateItem(BusinessTypeDTO)
        .then((res) => {
          if (res.RspCode == "1") {
            this.$message({
              message: "商户类型修改成功!",
              type: "success",
            });

           this.$emit("clickOk", {});
          } else {
            this.$message({
              showClose: true,
              message: "修改商户类型失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "商户类型修改";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "商户类型修改成功" : "修改商户类型失败";
          this.logInfo.ModuleName = "商户类型管理";
          this.logInfo.PageName = "商户类型管理详情页面";
          this.addOperationLog();
        })
        .catch((e) => {
          console.log("修改商户类型异常",e);
          this.$message({
            showClose: true,
            message: e.RspMsg ? "修改商户类型失败！" + e.RspMsg : "修改商户类型失败！",
            type: "error",
          });
          return false;
        });
    },
  },
};
</script>
